const mutations= {
      setCreateAccrualForm(state, payload) {
        state.createAccrualFormData.accrualId = payload.accrualId;
        state.createAccrualFormData.accrualForm =payload.Form;
      },
      setAccrualList(state, payload) {
        state.accrualList = payload;
      },
}
export default mutations;